module.exports = __webpack_public_path__ + "img/media_16.00333e8d.jpg";